import "./NewsItemDialogComponent.scss";
import template from "./NewsItemDialogComponent.html";
import {IComponentOptions} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {NewsHeadlineViewModel} from "../../models/NewsHeadlineViewModel";

export const NewsItemDialog = "tfNewsItemDialog";

export function newsItemDialog(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controllerAs: "ctrl",
        controller: NewsItemDialogComponentController
    };
}

interface Resolve {
    headline: NewsHeadlineViewModel;
    story: string | null;
}

export class NewsItemDialogComponentController {

    /** @input */
    public readonly modalInstance: IModalInstanceService;

    /** @input */
    public readonly resolve: Resolve;

    public get headline(): NewsHeadlineViewModel {
        return this.resolve.headline;
    }

    public get storyMissing(): boolean {
        return this.resolve.story == null;
    }

    public get story(): string | null {
        return this.resolve.story;
    }
}
